import { render, staticRenderFns } from "./LineOverflow.vue?vue&type=template&id=118b32cd&scoped=true"
import script from "./LineOverflow.vue?vue&type=script&lang=js"
export * from "./LineOverflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b32cd",
  null
  
)

export default component.exports